import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/auth/Login.tsx";
import Signup from "./pages/auth/Signup.tsx";
import ForgotPassword from "./pages/auth/ForgotPassword.tsx";
import Dashboard from "./pages/shared/Dashboard.tsx";
import ProtectedRoute from "./components/ProtectedRoute.tsx";
import { ToastProvider } from "./components/common/ToastContext.tsx";
import { ThemeProvider } from "./contexts/ThemeContext.tsx";
import ThemeChanger from "./components/ThemeChanger.tsx";


const App = () => {
  return (
    <ThemeProvider>
      <ToastProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route
              path="/dashboard/*"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
        {/* <ThemeChanger /> */}
      </ToastProvider>
    </ThemeProvider>
  );
};

export default App;
